module.exports = __webpack_public_path__ + "img/my-team-screenshot.a134a99e.png";